import React from "react";

import HomeNavbar from "../LandingPage/Components/Navbar";
import AdminProfilePage from "../AdminPage/Profile/Profile";

const UserProfile = () => {
  return (
      <>
          <HomeNavbar />
          <AdminProfilePage/>
          
     
    
    </>
  );
};

export default UserProfile;
